import type { User } from './types';

export function hasReceptionAllBranchesGrant(user: Pick<User, 'role' | 'can_manage_reception_all_branches' | 'simulation'> | null | undefined): boolean {
  return String(user?.role ?? '').trim().toLowerCase() === 'manager'
    && user?.can_manage_reception_all_branches === true
    && !user?.simulation?.active;
}
